import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Element } from 'react-scroll';
import { DEFAULT_HEADER_EDITORIAL, DEFAULT_HEADER_EDITORIAL_BAR } from './Header.constants';
import { HeaderRoot } from './Header.styled';
// Component.
// -----------------------------------------------------------------------------
const Header = forwardRef(({ align = 'inherit', children, as, editorial = DEFAULT_HEADER_EDITORIAL, editorialBar = DEFAULT_HEADER_EDITORIAL_BAR, size, anchor, ...rest }, ref) => (_jsx(HeaderRoot, { align: align, as: as, editorial: editorial, editorialBar: editorialBar, ref: ref, size: size, ...rest, children: _jsx("span", { className: "wrapper", children: _jsxs("span", { children: [anchor && (_jsxs(_Fragment, { children: [_jsx(Element, { name: anchor, id: anchor, as: "span", style: {
                                position: 'relative',
                                top: `-100px`,
                                display: 'block',
                                visibility: 'hidden',
                                height: 0,
                                width: 0
                            } }), _jsx("a", { href: `#${anchor}`, className: "anchor", children: "\uD83D\uDD17" })] })), children] }) }) })));
// Component configuration.
// -----------------------------------------------------------------------------
Header.displayName = 'Header';
export default Header;
//# sourceMappingURL=Header.js.map